import React from "react";

function Skills_Tools(){
    return(
        <>
            <div id="Skills" className="text-center m-2">
                <h2 className="btn-danger p-2"><strong>Skills & Tools</strong></h2>
                <div className="row home-row">
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg" alt="C" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg" alt="C++" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg" alt="JAVA" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg" alt="HTML5" width="80" height="80"/> 
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg" alt="CSS3" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg" alt="Javascript" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg" alt="nodejs" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg" alt="bootstrap" width="80" height="80"/>
                    </div>     
                    <div className="col-4 col-md-2 icon">
                        <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" alt="react" width="80" height="80"/>
                    </div>   
                    <div className="col-4 col-md-2 icon">
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original-wordmark.svg" alt="android" width="80" height="80"/>
                    </div>     
                    <div className="col-4 col-md-2 icon">
                        <img src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg" alt="git" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/androidstudio/androidstudio-original-wordmark.svg" alt="android-studio" width="80" height="80"/>
                    </div>
                    <div className="col-4 col-md-2 icon">
                        <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original-wordmark.svg" alt="visual-studio" width="80" height="80"/>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Skills_Tools;